export default function Features() {
  return (
    <section id="vidrieria" className="py-40 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-start justify-between mb-24">
          <div className="text-gray-700 font-light text-2xl tracking-widest">
            <div>M</div>
            <div>V</div>
          </div>
          
          <h2 className="text-7xl font-bold text-gray-900 text-center flex-1" style={{ fontFamily: 'Playfair Display, serif' }}>
            Servicios Especializados
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="bg-gray-900 rounded-[32px] p-12 relative overflow-hidden">
            <div className="absolute top-10 left-10 w-20 h-20 bg-gray-700 rounded-full flex items-center justify-center">
              <span className="text-white text-3xl font-bold">O</span>
            </div>
            
            <div className="mt-36">
              <h3 className="text-4xl font-bold text-white mb-4">Ojillado Profesional</h3>
              <p className="text-gray-400 text-lg">Instalación perfecta</p>
              
              <p className="text-gray-300 mt-8 leading-relaxed text-lg">
                Servicio de ojillado de cuadros para una correcta instalación y presentación de obras, 
                facilitando su colocación y conservación con técnicas profesionales.
              </p>
            </div>
          </div>

          <div className="relative rounded-[32px] overflow-hidden h-[500px]">
            <img
              src="https://public.readdy.ai/ai/img_res/70102aacbc32d5d738932c58c37df29c.jpg"
              alt="Vidriería"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/60"></div>
            
            <div className="absolute top-10 left-10 bg-black/60 backdrop-blur-sm px-6 py-3 rounded-full flex items-center gap-3">
              <i className="ri-scissors-cut-line text-white text-xl w-6 h-6 flex items-center justify-center"></i>
              <span className="text-white text-base font-medium">Vidriería</span>
            </div>
            
            <div className="absolute bottom-10 left-10 right-10">
              <h3 className="text-4xl font-bold text-white mb-4">Corte e instalación de vidrio</h3>
              <p className="text-gray-200 text-lg mt-3">
                Servicios de vidriería con corte e instalación de vidrio para diferentes usos, 
                trabajando con precisión y materiales de calidad.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-[32px] p-12">
            <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Espejos Decorativos
            </h3>
            <p className="text-gray-600 text-lg mb-10">Diferentes tamaños y estilos</p>
            
            <div className="rounded-2xl overflow-hidden h-72 w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Collection%20of%20decorative%20mirrors%20in%20various%20sizes%20and%20elegant%20frames%2C%20modern%20and%20classic%20mirror%20designs%20for%20home%20and%20business%2C%20beautifully%20framed%20mirrors%20with%20ornate%20and%20minimalist%20styles%2C%20mirror%20showroom%20display%20with%20diverse%20frame%20options%2C%20high-quality%20decorative%20mirrors%20for%20interior%20design&width=400&height=300&seq=feature-mirrors-1&orientation=landscape"
                alt="Espejos"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <p className="text-gray-700 mt-8 leading-relaxed text-lg">
              Disponemos de espejos ideales para hogares, negocios y proyectos decorativos, 
              con opción de enmarcado personalizado según preferencia del cliente.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
